import { render, staticRenderFns } from "./ListProjectLink.vue?vue&type=template&id=6f0ac512&scoped=true&"
import script from "./ListProjectLink.vue?vue&type=script&lang=js&"
export * from "./ListProjectLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0ac512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
